import React from 'react';

interface FooterProps {
  onPageChange: (pageId: string, mediaTitle?: string) => void;
}

const Footer: React.FC<FooterProps> = ({ onPageChange }) => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-midnight py-16 border-t border-white/5 mt-auto relative overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full bg-gradient-to-t from-gold/5 to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center mb-16">
          {/* TASTO TORNA SU */}
          <div 
            onClick={scrollToTop}
            className="flex flex-col items-center group cursor-pointer"
          >
            <div className="relative flex items-center justify-center w-14 h-14 mb-3">
              {/* Effetto impulso esterno */}
              <div className="absolute inset-0 rounded-full border border-gold opacity-20 animate-ping" />
              {/* Cerchio del tasto */}
              <div className="absolute inset-0 rounded-full border border-gold/40 group-hover:border-gold transition-all duration-300 bg-midnight/40 backdrop-blur-sm" />
              {/* Icona Freccia Su - Animata */}
              <svg 
                className="w-6 h-6 text-gold animate-bounce" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
                style={{ animationDuration: '2s' }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 10l7-7m0 0l7 7m-7-7v18" />
              </svg>
            </div>
            <span className="text-gold text-[10px] uppercase tracking-[0.5em] opacity-60 group-hover:opacity-100 transition-opacity">
              Torna Su
            </span>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center border-t border-white/5 pt-12">
          <div className="mb-8 md:mb-0 text-center md:text-left">
            <h3 
              className="text-xl md:text-2xl font-brand text-gold cursor-pointer tracking-tight"
              onClick={() => onPageChange('home')}
            >
              La Bottega Delle Voci
            </h3>
            <p className="text-sm text-white/30 mt-2 uppercase tracking-[0.2em]">Coro Polifonico</p>
          </div>
          
          <div className="flex space-x-8 mb-8 md:mb-0">
            <button onClick={() => onPageChange('contatti')} className="text-white/40 hover:text-gold transition-colors text-sm uppercase tracking-widest">Collabora</button>
            <button onClick={() => onPageChange('media')} className="text-white/40 hover:text-gold transition-colors text-sm uppercase tracking-widest">Multimedia</button>
          </div>

          <div className="text-center md:text-right">
            <p className="text-sm text-white/30">
              © {new Date().getFullYear()} La Bottega Delle Voci. Tutti i diritti riservati.
            </p>
            <p className="text-xs text-white/20 mt-1 uppercase tracking-widest">
              L'armonia è un'arte collettiva
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;